import { UrlBuilder } from "@sincro/url-builder";

const UrlUtil = new UrlBuilder();

export const getAppServiceApiUrl = () =>
  `${UrlUtil.getApiDomain()}/dcc-app/v1/me/apps`;
export const getDccDashboardUrl = () => UrlUtil.getPortalDomain();
export const getEnv = () => UrlUtil.getEnv();
export const getLoginServiceApiUrl = () =>
  `${UrlUtil.getLoginUrl(getDccDashboardUrl())}`;
export const getUserServiceApiUrl = () =>
  `${UrlUtil.getApiDomain()}/user/v1/me`;
export const getWsmUrl = () => UrlUtil.getWsmUrl();
